import IpInfo from './IpInfo';

export default IpInfo;
